import React, { useState } from 'react';

import { MFA_SMS_KEY } from 'lib/mfa';
import { formatPhoneNumber } from 'lib/utils';
import { ActionButton, ButtonV2, TextInput } from 'components';

function SetupSms({ onPrevious, onContinue }) {
  const [phoneNumber, setPhoneNumber] = useState('');

  const updatePhoneNumber = value => setPhoneNumber(formatPhoneNumber(value));

  const phoneNumberIsValid = value => /\([0-9]{3}\)-[0-9]{3}-[0-9]{4}$/.test(value);

  const submit = async () => {
    try {
      const digits = phoneNumber.replace(/\D/g, '');
      const result = await req.mfaCreateAuthenticator({ kind: MFA_SMS_KEY, identifier: digits });
      onContinue({ otpSecret: result.otp_secret });
    } catch {
      Actions.reportError('Unable to send verification code');
    }
  };

  return (
    <>
      <div className="modal__header mfa-add-method">
        <div className="modal__header-title">
          <ActionButton iconName="back" size={14} onClick={onPrevious} />
          Set Up Text Messages{' '}
          <label>
            <strong>Step 2</strong> / 3
          </label>
        </div>
      </div>
      <div className="modal__container">
        <div className="mfa-add-method__description">
          Use a cell phone number capable of receiving text messages. This will be used to deliver verification codes
          and help to validate your identity at login. Message and data rates apply.
        </div>
        <div className="mfa-add-method__label">Enter Cell Phone Number</div>
        <TextInput value={phoneNumber} onChange={updatePhoneNumber} placeholder="(000)-000-0000" />
        <div className="mfa-add-method__footnote">Procare will never share or market to this information.</div>
      </div>
      <div className="modal__footer">
        <ButtonV2
          className="button--primary"
          label="Verify Text Message"
          onClick={submit}
          disabled={!phoneNumberIsValid(phoneNumber)}
        />
      </div>
    </>
  );
}

export default SetupSms;
